import type { CombinedError } from 'urql';

type ErrorListener = (error: CombinedError) => void;

class ErrorEventEmitter {
  private listeners: ErrorListener[] = [];

  /**
   * Subscribe to error events
   * @param listener The function to call when an error occurs
   * @returns A function to unsubscribe the listener
   */
  subscribe(listener: ErrorListener): () => void {
    this.listeners.push(listener);

    // Return unsubscribe function
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  /**
   * Emit an error event to all listeners
   * @param error The GraphQL error to emit
   */
  emit(error: CombinedError): void {
    this.listeners.forEach((listener) => listener(error));
  }
}

export const errorEventEmitter = new ErrorEventEmitter();
